/**
 * Parse a date string coming from the API into a timestamp.
 *
 * API returns UTC without an offset ("2026-08-14T13:09:38.042535"), and JS parses
 * that form as local time — pin it to UTC explicitly. Strings that already carry
 * a timezone (Z or ±HH:MM) are passed through untouched.
 */
export const parseApiDate = (value: string): number => {
  const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/i.test(value)
  return new Date(hasTimezone ? value : `${value}Z`).getTime()
}
